module.exports = __webpack_public_path__ + "img/icon_box_2_1.f9a3e333.png";